import React from 'react';
import './NotFound .css'
const NotFound = () => {
    return (
        <div className='notfound'>
            <h1 className="text-center"> Page NotFound 404 !</h1>
        </div>
    );
};

export default NotFound;